//Libs
import React from "react";
import { Link, Redirect, withRouter } from "react-router-dom";
import { compose } from "redux";
import { connect } from "react-redux";
import {
  selectCurrentUser,
  selectSessionExpired,
  selectMsgChangePassConfigUser,
} from "Redux/User/user-selectors";
import {
  setCurrentUser,
  changeMessageWhenIsExpired,
  changeStatePassConfigUser,
} from "Redux/User/user-actions";
import { setModuleOrganization } from "Redux/DynamicConfigCompany/dcc-action";
import { selectOrganizacion } from "Redux/DynamicConfigCompany/dcc-select";
import { setOrganizationSeleted } from "Redux/Organization/organizarion-action";

//selector
import { selectCompany } from "Redux/DynamicConfigCompany/dcc-select";
//Components
import FormInput from "Components/FormInput/FormInput";
import CustomButton from "Components/CustomButton/CustomButton";
import Spinner from "Components/Spinner/Spinner";
import Background from "Assets/Background.jpg";
import logoAsocar from "Assets/POLPO_SUMMIT_LOGI.png";
//Services
import { login } from "Services/UserService";
import Mixpanel from "Services/MixPanelService";
//Config
import { ROUTES } from "Config/config";
//Styles
import "./SignIn.css";

class SignIn extends React.Component {
  constructor() {
    super();
    this.state = {
      loading: false,
      email: "",
      password: "",
      isFailLogin: false,
    };
  }
  // this componentDidMonunt is used for change state redux when the tokan is expired
  componentDidMount() {
    if (this.props.sessionExpired) {
      setTimeout(() => {
        this.props.setChangeMessageExpiredStatus();
      }, 10000);
    }
    if (this.props.MsgLoginReload) {
      setTimeout(() => {
        this.props.changeStatePassConfigUser();
      }, 5000);
    }
  }
  //This CALL DEFAUL LOGIN
  componentWillMount() {
    this.defaulLogin()
  }

  async defaulLogin() {

    const { setCurrentUser } = this.props;

    const loginResult = await login();
    setCurrentUser(loginResult);

    if (loginResult.organizations.length <= 1) {
      this.props.setOrganizationModule(loginResult.organizations[0]);
      await this.props.setOrganizationSeleted(loginResult.organizations[0]);

      this.props.history.push(ROUTES.HOME);
    } else {
      this.props.history.push(ROUTES.ORGANIZATION);
    }
  }

  handleSubmit = async (event) => {
    event.preventDefault();
    const { email, password } = this.state;
    const { setCurrentUser, company } = this.props;
    try {
      this.setState({
        loading: true,
      });
      const loginResult = await login(email, password, company.id);
      this.setState({
        loading: false,
      });
      if (!loginResult) {
        this.setState({
          isFailLogin: true,
        });
        setTimeout(() => {
          this.setState({
            isFailLogin: false,
          });
        }, 5000);
        return;
      }

      setCurrentUser(loginResult);

      if (loginResult.organizations.length <= 1) {
        this.props.setOrganizationModule(loginResult.organizations[0]);
        await this.props.setOrganizationSeleted(loginResult.organizations[0]);

        this.props.history.push(ROUTES.HOME);
      } else {
        this.props.history.push(ROUTES.ORGANIZATION);
      }
    } catch (err) {
      console.error(err);
    }
  };

  handleChange = (event) => {
    let { value, name } = event.target;

    if (name === "email") {
      value = value.toLowerCase();
    }

    this.setState({ [name]: value });
  };

  render() {
    const { loading, isFailLogin } = this.state;
    const { currentUser } = this.props;

    return currentUser ? (
      <Redirect to={ROUTES.HOME} />
    ) : (
      !currentUser ? <Spinner /> : <div className="signin">
        {loading && <Spinner />}
        <div
          className="signin__bg"
          style={{
            backgroundImage: `url(${Background})`,
            backgroundSize: "cover",
          }}
        />
        <div className="signin__container">
          <div className="signin__logos">
            <img
              alt="Logo ASOCAR"
              className="signin__logo-asocar"
              src={logoAsocar}
            />
          </div>
          <div className="signin__shadow">
            <h1 className="signin__title">Iniciar Sesión</h1>
            {this.props.sessionExpired && (
              <p class="signin__session-expired">
                Su sesión ha expirado o ha iniciado sesión en otro dispositivo.
              </p>
            )}
            {this.props.MsgLoginReload && (
              <p class="signin__session-expired">
                Es necesario que vuelva a ingresar después de cambiar su
                contraseña.
              </p>
            )}
            <form
              action="POST"
              autoComplete="new-password"
              onSubmit={this.handleSubmit}
            >
              <FormInput
                name="email"
                type="email"
                maxLength={150}
                value={this.state.email}
                onChange={this.handleChange}
                label="Email"
                required
              />

              <FormInput
                name="password"
                type="password"
                value={this.state.password}
                onChange={this.handleChange}
                label="Contraseña"
                required
              />

              {isFailLogin === true && (
                <div className="signin__error-container">
                  <span className="signin__error">
                    Usuario o contraseña incorrecta
                  </span>
                </div>
              )}
              <div className="signin__btn-container">
                <div className="signin__btn">
                  <CustomButton style={{ width: "100%", BackgroundColor: "#00B2F3" }} color="#00B9FD" type="submit">
                    Iniciar Sesión
                  </CustomButton>
                </div>
              </div>
            </form>
            <div style={{ marginTop: "10px" }} className="signin__option">
              <span className="signin__option--newuser">
                ¿Olvidaste tu contraseña?
              </span>
              <Link
                to={ROUTES.FORGOT_PASSWORD}
                className="signin__option--link"
                onClick={() => {
                  Mixpanel.track(Mixpanel.TYPES.FORGOT_PASSWORD);
                }}
              >
                Recuperar.
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  currentUser: selectCurrentUser(state),
  company: selectCompany(state),
  Organization: selectOrganizacion(state),
  sessionExpired: selectSessionExpired(state),
  MsgLoginReload: selectMsgChangePassConfigUser(state),
});

const mapDispatchToProps = (dispatch) => ({
  setCurrentUser: (user) => dispatch(setCurrentUser(user)),
  setOrganizationModule: (organizationSelect) =>
    dispatch(setModuleOrganization(organizationSelect)),
  setOrganizationSeleted: (organization) =>
    dispatch(setOrganizationSeleted(organization)),
  setChangeMessageExpiredStatus: () => dispatch(changeMessageWhenIsExpired()),
  changeStatePassConfigUser: () => dispatch(changeStatePassConfigUser()),
});

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(React.memo(SignIn));
